module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hant/4-9565d6a6dec28b6e2aa722ab214b4a69.jpg";